
import React, { useState } from 'react'
import {AppGridBar,AppForm,AppGridTabs, AppTable} from 'qcc'
import { Row, Col} from 'antd';
import api, {PosCustomerSeachor,PosAppTradeOutput} from 'api';
import {PosApiInputBar} from '../components/PosApiInputBar'
import {PosApiInputContent} from '../components/PosApiInputContent'
// scj:收筹金 slk:收楼款 sdsf:收代收费用 sbck:收补差款
let inputConfig = {
    example : {scene:"sbck",projectId:830810371568,idNumber:"429005199204170085",tell:"18571839160"} as PosCustomerSeachor,
    formdata:{} as PosCustomerSeachor,
    labelWidth:100 ,
    items:
    [
        {lable:'获取场景',field:'scene',placeholder:'string类型,scj:收筹金 slk:收楼款 sdsf:收代收费用 sbck:收补差款'},
        {lable:'项目ID',field:'projectId',placeholder:'number类型' ,dataype:'number'},
        {lable:'身份证号',field:'idNumber',placeholder:'string类型'},
        {lable:'电话',field:'tell',placeholder:'string类型'},
    ]
} as PosCustomerSeachor;

let outputExample = {
    code: 200,
    msg: null,
    data: {
        customer: {
            id: 1,
            createdBy: null,
            createdOn: null,
            modifiedBy: null,
            modifiedOn: null,
            name: "陈",
            idNumber: "429005199204170085",
            tell: "18571839160",
            zjType: null,
            zjTypeCode: null,
            erpId: null
        },
        tradeList: [],
        feeList: [
            {
                id: 4,
                roomName: null,
                projectName: "test",
                fundName: "定金",
                fundAmount: 4000000,
                fundActual: 1000000,
                ye: 3000000,
                actualNumber: "1541655"
            }
        ],
        bankList: []
    }
} as PosAppTradeOutput

export interface Props{
    current?:string
}

export const AppGetFee = (props:Props) =>{

    const[outputResult,setOutputResult]  = useState(null as PosAppTradeOutput)
    const[outputView,setOutputView]  = useState(0)

    const execApi = async () =>{
        let inputParam = refPosApiInputContent.current.getFormData();
        let res = await api.posapp.getFee(inputParam);
        setOutputResult(res);
    }

    const renderOutput = () =>{
        if(outputResult===null) return '';
        switch(outputView){
            case 0:
            return renderOutputForm();
            case 1:
            return rendertradeListTable();
            case 2:
            return renderFeeListTable();
            case 3:
            return renderBankListTable();
            case 4:
            return renderJson();
        }

        return '';
    }

    const renderOutputForm = () =>{
        return ( <AppForm  loadingData={false} formData={{...outputResult.customer}}>
            <AppForm.Section labelWidth={150}>
                <AppForm.Item label='姓名:' field='name' itemType='input' readonly/>
                <AppForm.Item label='电话:' field='tell' itemType='input' readonly/>
                <AppForm.Item label='证件号码:' field='idNumber' itemType='input' readonly/>
                <AppForm.Item label='证件类型:' field='zjType' itemType='input' readonly/>
                <AppForm.Item label='证件类型编码:' field='zjTypeCode' itemType='input' readonly/>
                <AppForm.Item label='外部系统ID:' field='erpId' itemType='input' readonly/>
            </AppForm.Section>
        </AppForm>)
    }

    const rendertradeListTable=()=>{
        let list = null;
        if(outputResult.tradeList){
            list = outputResult.tradeList;
        }
        if(list){
            return(
                <AppTable dataSource={list}>
                    <AppTable.ColIndex/>
                    <AppTable.Col field='id' />
                    <AppTable.Col field='roomName' />
                    <AppTable.Col field='projectName' />
                    <AppTable.Col field='auart' />
                    <AppTable.Col field='auartName' />
                </AppTable>
            )

        }else{
            return null;
        }
    }
    const renderFeeListTable=()=>{
        let list = null;
        if(outputResult.feeList){
            list = outputResult.feeList;
        }
        if(list){
            return(
                <AppTable dataSource={list}>
                    <AppTable.ColIndex/>
                    <AppTable.Col field='id' />
                    <AppTable.Col field='roomName' />
                    <AppTable.Col field='projectName' />
                    <AppTable.Col field='ActualNumber' />
                    <AppTable.Col field='fundName' />
                    <AppTable.Col field='fundAmount' />
                    <AppTable.Col field='fundActual' />
                    <AppTable.Col field='ye' />
                </AppTable>
            )
        }else{
            return null;
        }
    }

    const renderBankListTable=()=>{
        let list = null;
        if(outputResult.bankList){
            list = outputResult.bankList;
        }
        if(list){
            return(
                <AppTable dataSource={list}>
                    <AppTable.ColIndex/>
                    <AppTable.Col field='id' />
                    <AppTable.Col field='bankName' />
                    <AppTable.Col field='bankNumber' />
                </AppTable>
            )
        }else{
            return null;
        }
    }

    const renderJson = () =>{
        return <pre>{JSON.stringify(outputResult, null, 4)}</pre>
    } 
    
    let refPosApiInputContent = React.createRef<PosApiInputContent>();
    return (<div className='app-demo-content'>
            <h1>PosApp获取交易</h1>    
            <div>
                1、Pos端获取客户交易<br/>
                2、地址：/api/posApp/getFee <br/>
            </div>

            <div className='app-pos-api-input'>
                <PosApiInputBar  fn={execApi}/>
                <div className='app-pos-api-input-line'/>
                <PosApiInputContent ref={refPosApiInputContent} config={inputConfig} />
            </div>

            <div className='app-pos-api-input'>
                <AppGridBar>
                    <AppGridBar.Left>
                        <AppGridTabs defaultTabIndex={outputView} 
                        onChange={(tabIndex)=>{setOutputView(tabIndex)}} 
                        tabs={['表单（customer）','列表（tradeList）','列表（feeList）','列表（bankList）','JSON']}/>
                    </AppGridBar.Left>
                </AppGridBar>
                <div className='app-pos-api-input-line'/>
                <Row className='app-pos-api-input-content'>
                    <Col span={16} className='app-pos-api-input-form'>
                        {renderOutput()}
                    </Col>
                    <Col span={8} className='app-pos-api-input-example'>
                        <div>示例：</div>
                        <pre>{JSON.stringify(outputExample, null, 4)}</pre>
                    </Col>
                </Row>

            </div>

            
            
    </div>)
}


// WEBPACK FOOTER //
// ./src/posapi/app/AppGetFee.tsx